import { validationMessages } from './validationMessages.schema';

export default {
  title: 'Środki wypłacone',
  type: 'object',

  properties: {
    date: {
      fieldRequired: true,
      format: 'date',
      title: 'Data wypłacenia środków',
      type: 'string'
    }
  },

  allOf: [validationMessages]
};
